module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"404":"Die angegebene Einrichtung bzw. RA-ID ist uns leider nicht bekannt. Wenn Sie einen Fehler vermuten, wenden Sie sich bitte an Ihren Teilnehmerservice."},"en":{"404":"The given CA-Name / RA-ID is unknown in our system."}}')
  delete Component.options._Ctor
}
